import { CSSProperties } from 'react';
import LEMON from './lemon.png';
import { useBubbleSrc } from './bubble';

export const useAssetsCssProperties = (): CSSProperties => {
  const BUBBLE = useBubbleSrc();

  return {
    '--image-bubble': `url(${BUBBLE})`,
    '--image-lemon': `url(${LEMON})`,
  } as CSSProperties;
};
